import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './status.module.scss';

const Status = ({ item }) => {
  const options = {
    'active': {
      style: styles.new,
      name: 'New'
    },
    'in_progress': {
      style: styles.InProgress,
      name: 'In Progress'
    },
    'completed': {
      style: styles.completed,
      name: 'Completed'
    }
  };
  return (
    <div className={options[item]?.style}>
      <FormattedMessage id={`training.list.table.status.${options[item]?.name}`} defaultMessage={options[item]?.name} />
    </div>
  );
};

Status.propTypes = {
  item: PropTypes.number.isRequired
};
export default Status;
